/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { APPROVAL_STATUS } from '../../utils/enums';

type props = {
  type: any;
  data: any;
};

const ProfileTop = ({ type, data }: props) => {
  return (
    <>
      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s">
            <div className="profile_image">
              <figure>
                <img src={data?.image || '/static/images/user_placeholder.png'} alt="Profile" />
                {data?.status === APPROVAL_STATUS.APPROVED ? (
                  <span>
                    <img src="/static/images/verified_icon.svg" alt="Icon" />
                  </span>
                ) : null}
              </figure>
              {/* <p>#CR1987876</p> */}
            </div>
            <div className="profile_info">
              <h2>
                <b>{data?.name || '-'}</b>
                {/* <span>
                  <StarIcon /> 5 Stars (52)
                </span> */}
              </h2>
              <ul className="text_list">
                <li>
                  <img src="/static/images/sms_icon.svg" alt="Icon" /> {data?.email || '-'}
                </li>
                <li>
                  <img src="/static/images/calling_icon.svg" alt="Icon" />{' '}
                  {`${data?.dialCode} ${data?.phoneNo || '-'}`}
                </li>
              </ul>
              <ul className="box_list">
                <li>
                  <h3>
                    <img
                      src="/static/images/checking.png"
                      alt="Icon"
                      style={{ maxWidth: '20px' }}
                    />{' '}
                    {data?.noOfPosts || 0}
                  </h3>
                  <p>Number of posts</p>
                </li>
                {/* <li>
                  <h3>
                    <img src="/static/images/orders_icon.svg" alt="Icon" /> 125
                  </h3>
                  <p>Delivered orders</p>
                </li> */}
              </ul>
            </div>
          </div>
          <div className="right_s">
            {type === 'dealer' || type === 'store' ? (
              <div className="profile_image">
                <figure>
                  <img
                    src={data?.store?.image?.[0] || '/static/images/car_image.jpeg'}
                    alt="Profile"
                  />
                </figure>
                <p>{data?.store?.storeName || ''}</p>
              </div>
            ) : null}
            {/* <div className="social_icons">
              <IconButton>
                <img src="/static/images/facebook_icon.svg" alt="Icon" />
              </IconButton>
              <IconButton>
                <img src="/static/images/instagram_icon.svg" alt="Icon" />
              </IconButton>
              <IconButton>
                <img src="/static/images/twitter_icon.svg" alt="Icon" />
              </IconButton>
              <IconButton>
                <img src="/static/images/youtube_icon.svg" alt="Icon" />
              </IconButton>
            </div> */}

            {/* <div className="progress_info">
              <h3>On time Delivery</h3>
              <div>
                <Slider
                  value={typeof value1 === "number" ? value1 : 0}
                  onChange={handleSliderChange1}
                  aria-labelledby="input-slider"
                />
                <Input
                  value={value1}
                  size="small"
                  onChange={handleInputChange1}
                  onBlur={handleBlur1}
                  inputProps={{
                    step: 10,
                    min: 0,
                    max: 100,
                    type: "number",
                    "aria-labelledby": "input-slider",
                  }}
                />
              </div>

              <h3>Quality of deliver</h3>
              <div>
                <Slider
                  value={typeof value2 === "number" ? value2 : 0}
                  onChange={handleSliderChange2}
                  aria-labelledby="input-slider"
                />
                <Input
                  value={value2}
                  size="small"
                  onChange={handleInputChange2}
                  onBlur={handleBlur2}
                  inputProps={{
                    step: 10,
                    min: 0,
                    max: 100,
                    type: "number",
                    "aria-labelledby": "input-slider",
                  }}
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileTop;
